// // import React, { useEffect, useState } from "react";
// // import { Box, Card, CardContent, Typography } from "@mui/material";
// // import right from "../icon/right.png";
// // import { getAllApplications } from "../api";

// // function StatsCards() {
// //   const [summary, setSummary] = useState({
// //     today: { total: 0, approved: 0 },
// //     last7Days: { total: 0, approved: 0 },
// //     last30Days: { total: 0, approved: 0 },
// //   });
// //   const [loading, setLoading] = useState(false);

// //   useEffect(() => {
// //     const controller = new AbortController();
// //     setLoading(true);
// //     getAllApplications({ page: 1, limit: 1 }, { signal: controller.signal })
// //       .then((data) => {
// //         console.log('API Response:', data);
// //         if (data && data.summary) {
// //           console.log('Summary data:', data.summary);
// //           setSummary({
// //             today: {
// //               total: Number(data.summary.today?.total || 0),
// //               approved: Number(data.summary.today?.approved || 0),
// //             },
// //             last7Days: {
// //               total: Number(data.summary.last7Days?.total || 0),
// //               approved: Number(data.summary.last7Days?.approved || 0),
// //             },
// //             last30Days: {
// //               total: Number(data.summary.last30Days?.total || 0),
// //               approved: Number(data.summary.last30Days?.approved || 0),
// //             },
// //           });
// //         }
// //         setLoading(false);
// //       })
// //       .catch((e) => {
// //         if (e.name !== "AbortError") {
// //           setLoading(false);
// //         }
// //       });
// //     return () => controller.abort();
// //   }, []);

// //   const cardData = [
// //     {
// //       id: 1,
// //       title: "Today",
// //       totalValue: loading ? "--" : String(summary.today.total),
// //       approvedValue: loading ? "--" : String(summary.today.approved),
// //       totalIcon: right,
// //       approvedIcon: right,
// //     },
// //     {
// //       id: 2,
// //       title: "Last 7 Days",
// //       totalValue: loading ? "--" : String(summary.last7Days.total),
// //       approvedValue: loading ? "--" : String(summary.last7Days.approved),
// //       totalIcon: right,
// //       approvedIcon: right,
// //     },
// //     {
// //       id: 3,
// //       title: "Last 30 Days",
// //       totalValue: loading ? "--" : String(summary.last30Days.total),
// //       approvedValue: loading ? "--" : String(summary.last30Days.approved),
// //       totalIcon: right,
// //       approvedIcon: right,
// //     },
// //   ];

// //   return (
// //     <Box sx={{ 
// //       mx: "auto", 
// //       width: "100%", 
// //       maxWidth: "1500px",
// //       px: { xs: 1, sm: 2, md: 3 }
// //     }}>
// //       <Box
// //         sx={{
// //           display: "grid",
// //           gap: { xs: 1, sm: 1.5, md: 2 },
// //           gridTemplateColumns: {
// //             xs: "1fr",
// //             sm: "repeat(2, 1fr)",
// //             md: "repeat(3, 1fr)",
// //           },
// //           justifyContent: "center",
// //           alignItems: "stretch",
// //         }}
// //       >
// //         {cardData.map((card) => (
// //           <Card
// //             key={card.id}
// //             sx={{
// //               borderRadius: 2,
// //               bgcolor: "#C7C7C7",
// //               boxShadow: "0px 2px 12px rgba(0,0,0,0.1)",
// //               transition: "all 0.3s ease",
// //               "&:hover": {
// //                 transform: "translateY(-3px)",
// //                 boxShadow: "0px 4px 20px rgba(0,0,0,0.15)",
// //               },
// //               minHeight: { xs: 120, sm: 140 },
// //               display: "flex",
// //               flexDirection: "column",
// //             }}
// //           >
// //             <CardContent
// //               sx={{
// //                 p: { xs: 1.5, sm: 2 },
// //                 display: "flex",
// //                 flexDirection: "column",
// //                 gap: { xs: 1, sm: 1.5 },
// //                 flex: 1,
// //                 width: "100%",
// //                 boxSizing: "border-box",
// //               }}
// //             >
// //               {/* Title */}
// //               <Typography
// //                 sx={{
// //                   fontSize: { xs: "0.9rem", sm: "1.1rem", md: "1.25rem" },
// //                   fontWeight: 600,
// //                   color: "#034A7F",
// //                   textAlign: "left",
// //                   whiteSpace: "nowrap",
// //                   overflow: "hidden",
// //                   textOverflow: "ellipsis",
// //                 }}
// //               >
// //                 {card.title}
// //               </Typography>

// //               {/* Stats Row */}
// //               <Box
// //                 sx={{
// //                   display: "flex",
// //                   flexDirection: { xs: "column", sm: "row" },
// //                   justifyContent: "space-between",
// //                   alignItems: "stretch",
// //                   gap: { xs: 1, sm: 1.5 },
// //                   flex: 1,
// //                 }}
// //               >
// //                 {/* Total */}
// //                 <Box
// //                   sx={{
// //                     flex: 1,
// //                     bgcolor: "#034A7F",
// //                     borderRadius: 1.5,
// //                     p: { xs: 1, sm: 1.25 },
// //                     display: "flex",
// //                     alignItems: "center",
// //                     justifyContent: "center",
// //                     gap: { xs: 0.75, sm: 1 },
// //                     minWidth: 0,
// //                     minHeight: { xs: 50, sm: 60 },
// //                     boxSizing: "border-box",
// //                   }}
// //                 >
// //                   <Box
// //                     component="img"
// //                     src={card.totalIcon}
// //                     alt="Total"
// //                     sx={{
// //                       width: { xs: 18, sm: 22, md: 24 },
// //                       height: { xs: 18, sm: 22, md: 24 },
// //                       objectFit: "contain",
// //                       flexShrink: 0,
// //                     }}
// //                   />
// //                   <Typography
// //                     sx={{
// //                       fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" },
// //                       color: "#fff",
// //                       display: "flex",
// //                       alignItems: "center",
// //                       gap: 0.5,
// //                       lineHeight: 1.2,
// //                       fontWeight: 500,
// //                       flexWrap: "nowrap",
// //                       minWidth: 0,
// //                     }}
// //                   >
// //                     <span style={{ 
// //                       display: "inline-block",
// //                       overflow: "hidden",
// //                       textOverflow: "ellipsis",
// //                       whiteSpace: "nowrap"
// //                     }}>
// //                       Total
// //                     </span>
// //                     <span style={{ 
// //                       fontWeight: 700,
// //                       flexShrink: 0
// //                     }}>
// //                       {card.totalValue}
// //                     </span>
// //                   </Typography>
// //                 </Box>

// //                 {/* Approved */}
// //                 <Box
// //                   sx={{
// //                     flex: 1,
// //                     bgcolor: "#5ABA85",
// //                     borderRadius: 1.5,
// //                     p: { xs: 1, sm: 1.25 },
// //                     display: "flex",
// //                     alignItems: "center",
// //                     justifyContent: "center",
// //                     gap: { xs: 0.75, sm: 1 },
// //                     minWidth: 0,
// //                     minHeight: { xs: 50, sm: 60 },
// //                     boxSizing: "border-box",
// //                   }}
// //                 >
// //                   <Box
// //                     component="img"
// //                     src={card.approvedIcon}
// //                     alt="Approved"
// //                     sx={{
// //                       width: { xs: 18, sm: 22, md: 24 },
// //                       height: { xs: 18, sm: 22, md: 24 },
// //                       objectFit: "contain",
// //                       flexShrink: 0,
// //                     }}
// //                   />
// //                   <Typography
// //                     sx={{
// //                       fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" },
// //                       color: "#fff",
// //                       display: "flex",
// //                       alignItems: "center",
// //                       gap: 0.5,
// //                       lineHeight: 1.2,
// //                       fontWeight: 500,
// //                       flexWrap: "nowrap",
// //                       minWidth: 0,
// //                     }}
// //                   >
// //                     <span style={{ 
// //                       display: "inline-block",
// //                       overflow: "hidden",
// //                       textOverflow: "ellipsis",
// //                       whiteSpace: "nowrap"
// //                     }}>
// //                       Approved
// //                     </span>
// //                     <span style={{ 
// //                       fontWeight: 700,
// //                       flexShrink: 0
// //                     }}>
// //                       {card.approvedValue}
// //                     </span>
// //                   </Typography>
// //                 </Box>
// //               </Box>
// //             </CardContent>
// //           </Card>
// //         ))}
// //       </Box>
// //     </Box>
// //   );
// // }

// // export default StatsCards;


// import React, { useEffect, useState } from "react";
// import { Box, Card, CardContent, Typography } from "@mui/material";
// import right from "../icon/right.png";
// import { getAllApplications } from "../api";
 
// function StatsCards() {
//   const [summary, setSummary] = useState({
//     today: { total: 0, approved: 0 },
//     last7Days: { total: 0, approved: 0 },
//     last30Days: { total: 0, approved: 0 },
//   });
//   const [loading, setLoading] = useState(false);
 
//   useEffect(() => {
//     const controller = new AbortController();
//     setLoading(true);
//     getAllApplications({ page: 1, limit: 1 }, { signal: controller.signal })
//       .then((data) => {
//         console.log('API Response:', data);
//         if (data && data.summary) {
//           console.log('Summary data:', data.summary);
//           setSummary({
//             today: {
//               total: Number(data.summary.today?.total || 0),
//               approved: Number(data.summary.today?.approved || 0),
//             },
//             last7Days: {
//               total: Number(data.summary.last7Days?.total || 0),
//               approved: Number(data.summary.last7Days?.approved || 0),
//             },
//             last30Days: {
//               total: Number(data.summary.last30Days?.total || 0),
//               approved: Number(data.summary.last30Days?.approved || 0),
//             },
//           });
//         }
//         setLoading(false);
//       })
//       .catch((e) => {
//         if (e.name !== "AbortError") {
//           setLoading(false);
//         }
//       });
//     return () => controller.abort();
//   }, []);
 
//   const cardData = [
//     {
//       id: 1,
//       title: "Today",
//       totalValue: loading ? "--" : String(summary.today.total),
//       approvedValue: loading ? "--" : String(summary.today.approved),
//       totalIcon: right,
//       approvedIcon: right,
//     },
//     {
//       id: 2,
//       title: "Last 7 Days",
//       totalValue: loading ? "--" : String(summary.last7Days.total),
//       approvedValue: loading ? "--" : String(summary.last7Days.approved),
//       totalIcon: right,
//       approvedIcon: right,
//     },
//     {
//       id: 3,
//       title: "Last 30 Days",
//       totalValue: loading ? "--" : String(summary.last30Days.total),
//       approvedValue: loading ? "--" : String(summary.last30Days.approved),
//       totalIcon: right,
//       approvedIcon: right,
//     },
//   ];
 
//   return (
//     <Box sx={{
    
//       width: "100%",
    
//       px: 1.4
     
//     }}>
//       <Box
//         sx={{
//           display: "grid",
//           gap: { xs: 1, sm: 1.5, md: 2 },
//           gridTemplateColumns: {
//             xs: "1fr",
//             sm: "repeat(2, 1fr)",
//             md: "repeat(3, 1fr)",
//           },
//           justifyContent: "center",
//           alignItems: "stretch",
//         }}
//       >
//         {cardData.map((card) => (
//           <Card
//             key={card.id}
//             sx={{
//               borderRadius: 2,
//               bgcolor: "#C7C7C7",
//               boxShadow: "0px 2px 12px rgba(0,0,0,0.1)",
//               transition: "all 0.3s ease",
//               "&:hover": {
//                 transform: "translateY(-3px)",
//                 boxShadow: "0px 4px 20px rgba(0,0,0,0.15)",
//               },
//               minHeight: { xs: 120, sm: 140 },
//               display: "flex",
//               flexDirection: "column",
//             }}
//           >
//             <CardContent
//               sx={{
//                 p: { xs: 1.5, sm: 2 },
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: { xs: 1, sm: 1.5 },
//                 flex: 1,
//                 width: "100%",
//                 boxSizing: "border-box",
//               }}
//             >
//               {/* Title */}
//               <Typography
//                 sx={{
//                   fontSize: { xs: "0.9rem", sm: "1.1rem", md: "1.25rem" },
//                   fontWeight: 600,
//                   color: "#034A7F",
//                   textAlign: "left",
//                   whiteSpace: "nowrap",
//                   overflow: "hidden",
//                   textOverflow: "ellipsis",
//                 }}
//               >
//                 {card.title}
//               </Typography>
 
//               {/* Stats Row */}
//               <Box
//                 sx={{
//                   display: "flex",
//                   flexDirection: { xs: "column", sm: "row" },
//                   justifyContent: "space-between",
//                   alignItems: "stretch",
//                   gap: { xs: 1, sm: 1.5 },
//                   flex: 1,
//                 }}
//               >
//                 {/* Total */}
//                 <Box
//                   sx={{
//                     flex: 1,
//                     bgcolor: "#034A7F",
//                     borderRadius: 1.5,
//                     p: { xs: 1, sm: 1.25 },
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     gap: { xs: 0.75, sm: 1 },
//                     minWidth: 0,
//                     minHeight: { xs: 50, sm: 60 },
//                     boxSizing: "border-box",
//                   }}
//                 >
//                   <Box
//                     component="img"
//                     src={card.totalIcon}
//                     alt="Total"
//                     sx={{
//                       width: { xs: 18, sm: 22, md: 24 },
//                       height: { xs: 18, sm: 22, md: 24 },
//                       objectFit: "contain",
//                       flexShrink: 0,
//                     }}
//                   />
//                   <Typography
//                     sx={{
//                       fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" },
//                       color: "#fff",
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 0.5,
//                       lineHeight: 1.2,
//                       fontWeight: 500,
//                       flexWrap: "nowrap",
//                       minWidth: 0,
//                     }}
//                   >
//                     <span style={{
//                       display: "inline-block",
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                       whiteSpace: "nowrap"
//                     }}>
//                       Total
//                     </span>
//                     <span style={{
//                       fontWeight: 700,
//                       flexShrink: 0
//                     }}>
//                       {card.totalValue}
//                     </span>
//                   </Typography>
//                 </Box>
 
//                 {/* Approved */}
//                 <Box
//                   sx={{
//                     flex: 1,
//                     bgcolor: "#5ABA85",
//                     borderRadius: 1.5,
//                     p: { xs: 1, sm: 1.25 },
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     gap: { xs: 0.75, sm: 1 },
//                     minWidth: 0,
//                     minHeight: { xs: 50, sm: 60 },
//                     boxSizing: "border-box",
//                   }}
//                 >
//                   <Box
//                     component="img"
//                     src={card.approvedIcon}
//                     alt="Approved"
//                     sx={{
//                       width: { xs: 18, sm: 22, md: 24 },
//                       height: { xs: 18, sm: 22, md: 24 },
//                       objectFit: "contain",
//                       flexShrink: 0,
//                     }}
//                   />
//                   <Typography
//                     sx={{
//                       fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" },
//                       color: "#fff",
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 0.5,
//                       lineHeight: 1.2,
//                       fontWeight: 500,
//                       flexWrap: "nowrap",
//                       minWidth: 0,
//                     }}
//                   >
//                     <span style={{
//                       display: "inline-block",
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                       whiteSpace: "nowrap"
//                     }}>
//                       Approved
//                     </span>
//                     <span style={{
//                       fontWeight: 700,
//                       flexShrink: 0
//                     }}>
//                       {card.approvedValue}
//                     </span>
//                   </Typography>
//                 </Box>
//               </Box>
//             </CardContent>
//           </Card>
//         ))}
//       </Box>
//     </Box>
//   );
// }
 
// export default StatsCards;
 

import React, { useEffect, useState } from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import right from "../icon/right.png";
import { getAllApplications } from "../api";
 
function StatsCards({ onFilterChange }) {
  const [summary, setSummary] = useState({
    today: { total: 0, approved: 0 },
    last7Days: { total: 0, approved: 0 },
    last30Days: { total: 0, approved: 0 },
  });
  const [loading, setLoading] = useState(false);
 
useEffect(() => {
  const controller = new AbortController();
  setLoading(true);
 
  getAllApplications({}, { signal: controller.signal })
    .then((data) => {
      console.log('================ API FULL RESPONSE ================');
      console.log(data);
 
      console.log('SUMMARY:', data?.summary);
      console.log('APPLICATIONS LENGTH:', data?.applications?.length);
      console.log('APPLICATION IDS:', data?.applications?.map(a => a.applicationNo));
      console.log('PAGINATION:', data?.pagination);
      console.log('===================================================');
 
      if (data && data.summary) {
        setSummary({
          today: {
            total: Number(data.summary.today?.total || 0),
            approved: Number(data.summary.today?.approved || 0),
          },
          last7Days: {
            total: Number(data.summary.last7Days?.total || 0),
            approved: Number(data.summary.last7Days?.approved || 0),
          },
          last30Days: {
            total: Number(data.summary.last30Days?.total || 0),
            approved: Number(data.summary.last30Days?.approved || 0),
          },
        });
      }
      setLoading(false);
    })
    .catch((e) => {
      if (e.name !== "AbortError") {
        setLoading(false);
      }
    });
 
  return () => controller.abort();
}, []);
 
 
  // Define cardData here
  const cardData = [
    {
      id: 1,
      title: "Today",
      totalValue: loading ? "--" : String(summary.today.total),
      approvedValue: loading ? "--" : String(summary.today.approved),
      totalIcon: right,
      approvedIcon: right,
    },
    {
      id: 2,
      title: "Last 7 Days",
      totalValue: loading ? "--" : String(summary.last7Days.total),
      approvedValue: loading ? "--" : String(summary.last7Days.approved),
      totalIcon: right,
      approvedIcon: right,
    },
    {
      id: 3,
      title: "Last 30 Days",
      totalValue: loading ? "--" : String(summary.last30Days.total),
      approvedValue: loading ? "--" : String(summary.last30Days.approved),
      totalIcon: right,
      approvedIcon: right,
    },
  ];
 
  const handleCardClick = (period, type) => {
    // Only proceed if onFilterChange is provided
    if (!onFilterChange) return;
   
    let dateRange = { startDate: '', endDate: '' };
    const now = new Date();
   
    if (period === 'today') {
      const today = now.toISOString().split('T')[0];
      dateRange = { startDate: today, endDate: today };
    } else if (period === 'last7Days') {
      const sevenDaysAgo = new Date(now);
      sevenDaysAgo.setDate(now.getDate() - 7);
      dateRange = {
        startDate: sevenDaysAgo.toISOString().split('T')[0],
        endDate: now.toISOString().split('T')[0]
      };
    } else if (period === 'last30Days') {
      const thirtyDaysAgo = new Date(now);
      thirtyDaysAgo.setDate(now.getDate() - 30);
      dateRange = {
        startDate: thirtyDaysAgo.toISOString().split('T')[0],
        endDate: now.toISOString().split('T')[0]
      };
    }
 
    // Call parent function with filter data
    onFilterChange({
      ...dateRange,
      status: type === 'approved' ? ['Approved'] : ['Approved', 'Onboarding', 'Rejected']
    });
  };
 
  return (
    <Box sx={{
      width: "100%",
      // px: 1.4
    }}>
      <Box
        sx={{
          display: "grid",
          gap: { xs: 1, sm: 1.5, md: 2 },
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(3, 1fr)",
          },
          justifyContent: "center",
          alignItems: "stretch",
        }}
      >
        {cardData.map((card) => {
          const period = card.title === 'Today' ? 'today'
            : card.title === 'Last 7 Days' ? 'last7Days'
            : 'last30Days';
 
          return (
            <Card
              key={card.id}
              sx={{
                borderRadius: 2,
                bgcolor: "#C7C7C7",
                boxShadow: "0px 2px 12px rgba(0,0,0,0.1)",
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-3px)",
                  boxShadow: "0px 4px 20px rgba(0,0,0,0.15)",
                },
                minHeight: { xs: 120, sm: 140 },
                display: "flex",
                flexDirection: "column",
              }}
            >
              <CardContent
                sx={{
                  p: { xs: 1.5, sm: 2 },
                  display: "flex",
                  flexDirection: "column",
                  gap: { xs: 1, sm: 1.5 },
                  flex: 1,
                  width: "100%",
                  boxSizing: "border-box",
                }}
              >
                {/* Title */}
                <Typography
                  sx={{
                    fontSize: { xs: "0.9rem", sm: "1.1rem", md: "1.25rem" },
                    fontWeight: 600,
                    color: "#034A7F",
                    textAlign: "left",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {card.title}
                </Typography>
 
                {/* Stats Row */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    justifyContent: "space-between",
                    alignItems: "stretch",
                    gap: { xs: 1, sm: 1.5 },
                    flex: 1,
                  }}
                >
                  {/* Total - Now Clickable */}
                  <Box
                    onClick={() => handleCardClick(period, 'total')}
                    sx={{
                      flex: 1,
                      bgcolor: "#034A7F",
                      borderRadius: 1.5,
                      p: { xs: 1, sm: 1.25 },
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: { xs: 0.75, sm: 1 },
                      minWidth: 0,
                      minHeight: { xs: 50, sm: 60 },
                      boxSizing: "border-box",
                      cursor: onFilterChange ? 'pointer' : 'default',
                      transition: 'all 0.2s ease',
                      '&:hover': onFilterChange ? {
                        bgcolor: '#02365a',
                        transform: 'scale(1.02)',
                      } : {}
                    }}
                  >
                    <Box
                      component="img"
                      src={card.totalIcon}
                      alt="Total"
                      sx={{
                        width: { xs: 18, sm: 22, md: 24 },
                        height: { xs: 18, sm: 22, md: 24 },
                        objectFit: "contain",
                        flexShrink: 0,
                      }}
                    />
                    <Typography
                      sx={{
                        fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" },
                        color: "#fff",
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        lineHeight: 1.2,
                        fontWeight: 500,
                        flexWrap: "nowrap",
                        minWidth: 0,
                      }}
                    >
                      <span style={{
                        display: "inline-block",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap"
                      }}>
                        Total
                      </span>
                      <span style={{
                        fontWeight: 700,
                        flexShrink: 0
                      }}>
                        {card.totalValue}
                      </span>
                    </Typography>
                  </Box>
 
                  {/* Approved - Now Clickable */}
                  <Box
                    onClick={() => handleCardClick(period, 'approved')}
                    sx={{
                      flex: 1,
                      bgcolor: "#5ABA85",
                      borderRadius: 1.5,
                      p: { xs: 1, sm: 1.25 },
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: { xs: 0.75, sm: 1 },
                      minWidth: 0,
                      minHeight: { xs: 50, sm: 60 },
                      boxSizing: "border-box",
                      cursor: onFilterChange ? 'pointer' : 'default',
                      transition: 'all 0.2s ease',
                      '&:hover': onFilterChange ? {
                        bgcolor: '#4a9a70',
                        transform: 'scale(1.02)',
                      } : {}
                    }}
                  >
                    <Box
                      component="img"
                      src={card.approvedIcon}
                      alt="Approved"
                      sx={{
                        width: { xs: 18, sm: 22, md: 24 },
                        height: { xs: 18, sm: 22, md: 24 },
                        objectFit: "contain",
                        flexShrink: 0,
                      }}
                    />
                    <Typography
                      sx={{
                        fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" },
                        color: "#fff",
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        lineHeight: 1.2,
                        fontWeight: 500,
                        flexWrap: "nowrap",
                        minWidth: 0,
                      }}
                    >
                      <span style={{
                        display: "inline-block",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap"
                      }}>
                        Approved
                      </span>
                      <span style={{
                        fontWeight: 700,
                        flexShrink: 0
                      }}>
                        {card.approvedValue}
                      </span>
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          );
        })}
      </Box>
    </Box>
  );
}
 
export default StatsCards;
 
 